import React from "react";
import "../styles/Home.css";
import { NavLink } from "react-router-dom";
import BrandsWroked from "../assets/home/brandsworked.png";
import Projects from "../assets/home/projects.svg";

export default function Home() {
  return (
    <div className="home">
      <div className="home-header">
        <h1>
          I Craft <span> Innovative </span> Product Solutions.
        </h1>
      </div>
      <div className="home-body">
        <div className="home-body-left">
          <div className="home-body-left-division">
            <div className="home-body-box">
              <h1>6</h1> <p>Projects Completed</p>
            </div>
            <div className="home-body-box">
              <h2>Hands On</h2> <p2>Saas Platforms</p2>
              <p2>Mobile Apps</p2>
              <p2>Websites</p2>
            </div>
          </div>
          <div className="home-body-left-division">
            <div className="home-body-box">
              <h1>
                3<span>+</span>
              </h1>
              <p>Satisfied Clients</p>
            </div>
            <div className="home-body-box">
              <h1>
                6 <span>Years</span>
              </h1>
              <p>Digital Experience</p>
            </div>
          </div>
        </div>
        <div className="home-body-right">
          <h1>About Me</h1>
          <p>
            I am a UI/UX designer with six years of experience in creating
            engaging and easy-to-use digital experiences.
          </p>
          <p>
            Throughout my career, I have worked on a wide range of projects
            across various industries, including tech startups, and SaaS
            platform. My approach is rooted in user-centered design principles,
            ensuring that every project. I undertake is informed by real user
            insights and data. I am skilled in the entire design process, from
            initial research and wire-framing to high-fidelity prototyping and
            usability testing.
          </p>
          <NavLink to="/about" className="read-more-link">
            Read More <span>&gt;</span>
          </NavLink>
        </div>
      </div>
      <div className="home-body">
        <div className="home-body-left-second">
          <h1>My Projects</h1>
          <NavLink to="/portfolio" className="read-more-link">
            View All <span>&gt;</span>
          </NavLink>
          <img src={Projects} alt="Projects" />
        </div>
        <div className="home-body-right">
          <h1>Brands I Worked With</h1>
          <img src={BrandsWroked} alt="Brands Worked" />
        </div>
      </div>
    </div>
  );
}
